import { useContext } from 'react'
import { AbilityContext } from './AbilityContext'
export { AbilityContext }
export { default as abilityFor } from './ability'
export { default as Usuarios } from './Usuarios'
export { default as UsuarioTabs } from './UsuarioForm'
export const useAbility = () => useContext(AbilityContext)
